import React, { useState, useEffect } from "react";
import { getTestimonial } from "../Service/Api";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const AlumniForm = () => {
  useEffect(() => {
    document.title = "Alumni Form -  The Air Force School Subroto Park";
  }, []);
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Fetch data and process year/month ranges
  useEffect(() => {
    const fetchData = async () => {
      const galleryData = await getTestimonial();

      setData(galleryData);
      setFilteredData(galleryData); // Set the data as filterData initially

      // Extract unique years for the dropdown
      const uniqueYears = Array.from(
        new Set(
          galleryData.flatMap((item) => {
            if (item.fromDate) {
              const year = new Date(item.fromDate).getFullYear();
              return [year];
            }
            return [];
          }),
        ),
      );
      const uniqueYearRanges = uniqueYears
        .map((year) => `${year}`)
        .sort((a, b) => b - a);
      setYearRanges(uniqueYearRanges);
    };

    fetchData();
  }, []);

  // Filter data based on selected filters
  useEffect(() => {
    let filteredData = data;

    // If selectedYear is 'All', skip filtering by year
    if (selectedYear !== "All") {
      filteredData = filteredData.filter((item) => {
        if (item.fromDate && item.fromDate.trim() !== "") {
          const year = new Date(item.fromDate).getFullYear();
          return parseInt(selectedYear) === year;
        }
        return false;
      });
    }

    // Filter by search query
    if (searchQuery) {
      filteredData = filteredData.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    // Sort the filtered data by year and date in descending order
    filteredData.sort((a, b) => {
      const yearA = new Date(a.date).getFullYear();
      const yearB = new Date(b.date).getFullYear();
      if (yearA === yearB) {
        return new Date(b.date) - new Date(a.date); // Sort by date descending if years are the same
      }
      return yearB - yearA; // Sort by year descending
    });

    // Set filtered data
    setFilteredData(filteredData);
  }, [selectedYear, searchQuery, data]);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>

          <li>Alumni Form</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Alumni Form </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p>
                TAFS is a school that has been around for six decades and more.
                This school has touched many lives just as in return it has been
                shaped by many personalities. The bond between the school and
                the student is everlasting. We are looking out for all students
                who passed out of the portals of this school. It would be a
                great moment if we could catch a glimpse of you. In order to
                rediscover this connection between the alma mater and the
                students we have prepared a pro forma.This can be filled and
                sent back to us. It will help us create a community of ex
                Tafsians which would enrich our lives.
              </p>
              <p className="formlink">
                <Link to="/Alumni">Click Here to Alumni Form</Link>{" "}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="chooseyear">
                <select
                  id="chooseddlYear"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection"
                >
                  <option value="All">All</option>
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
              <div className="clr"></div>
              <div className="row alumnili">
                <ul className="list">
                  {filterData.length > 0 ? (
                    filterData.map((item, index) => (
                      <li key={index}>
                        <Link
                          to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                          target="_blank"
                        >
                          {item.name} - <b>Click Here</b>
                        </Link>
                      </li>
                    ))
                  ) : (
                    <p> </p>
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="Alumnibox">
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/TafsAlumna.pdf"
                    target="_blank"
                  >
                    {" "}
                    The Visit By The Tafs Alumna, Mrs. Rashmi Tiwari{" "}
                  </Link>{" "}
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Stress-Time-Management.pdf"
                    target="_blank"
                  >
                    {" "}
                    Stress And Time Management Workshop{" "}
                  </Link>{" "}
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Pocso-Workshop.pdf"
                    target="_blank"
                  >
                    {" "}
                    Pocso Workshop{" "}
                  </Link>{" "}
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Science-Gamification.pdf"
                    target="_blank"
                  >
                    {" "}
                    Science And Gamification Workshop - Class X{" "}
                  </Link>{" "}
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Healthy-Teeth.pdf"
                    target="_blank"
                  >
                    {" "}
                    Healthy Teeth. Healthy You{" "}
                  </Link>{" "}
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ShashwatDabas-2013Batch.pdf"
                    target="_blank"
                  >
                    {" "}
                    Shashwat Dabas (2013 Batch) Gifted A Guitar To The
                    School{" "}
                  </Link>{" "}
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/RepublicDayParade-2013Batch.pdf"
                    target="_blank"
                  >
                    {" "}
                    Capt Shashwat Dabas Leading Maratha Regiment In Republic Day
                    Parade Today Is Tafs Alumni Of 2013 Batch.{" "}
                  </Link>
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/AlumniVisit-1979Batch.pdf"
                    target="_blank"
                  >
                    {" "}
                    Alumni Visit :1979 Batch : 05 August 2023{" "}
                  </Link>
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/HealthCamp23Sep-2023.pdf"
                    target="_blank"
                  >
                    {" "}
                    Health Camp : 23 September 2023{" "}
                  </Link>
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SeniorDsC-labs.pdf"
                    target="_blank"
                  >
                    {" "}
                    Workshop By Group Captain Rahul Tyagi, Senior Ds C-labs{" "}
                  </Link>
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Ex-tafsian-Noted.pdf"
                    target="_blank"
                  >
                    {" "}
                    Visit By Kabir Sadanand, Ex-tafsian And Noted Tv & Film
                    Personality{" "}
                  </Link>
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/AlumunusOfTafs.pdf"
                    target="_blank"
                  >
                    {" "}
                    Visit By Mr Kush Mishra, Alumunus Of Tafs{" "}
                  </Link>
                </p>
                <p>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/VisitOf25Sep2024.pdf"
                    target="_blank"
                  >
                    {" "}
                    Visit Of 1974 Batch : 25 Sep 2024{" "}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AlumniForm;
